import React, { Suspense, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash.debounce';

import { handleCloseforDoorWindows, setActiveBuildingWall } from '../../action';
import { const_var, params } from '../../redux/reducers/reducer';
import WATERMARK_IMG from "../../assets/images/newWatermark/logo-sensei.svg";
import CanvasEnv from './CanvasEnv';
import Building from '../Building';
import CameraController from '../CameraController';
import * as cuComponent from "../../redux/reducers/building_component/componentReducer";
import { controls } from '../../redux/reducers/common/eventReducer';

const NewCanvas = () => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.reducer);
    // const handlePointerUp = debounce(() => {
    //     if (const_var.controls !== undefined && !const_var.componentsMoving) {
    //         if (const_var.wallSelection.leanToWall == "select") {
    //             const currentAzimuthalAngle = const_var.controls.getAzimuthalAngle();
    //             const camAngle = (Math.atan((params.p_d / 2) / (params.p_w / 2)))

    //             if (currentAzimuthalAngle >= -(Math.PI / 2 - camAngle) && currentAzimuthalAngle < (Math.PI / 2 - camAngle)) {
    //                 if (params.cB_addStorage_check_right === true && params.p_f_w != "Close") {
    //                     dispatch(setActiveBuildingWall('c_b_r_s_f_w'));
    //                 } else if (params.cB_addStorage_check_left === true && params.p_f_w != "Close") {
    //                     dispatch(setActiveBuildingWall('c_b_l_s_f_w'));
    //                 } else {
    //                     dispatch(setActiveBuildingWall('c_b_f_w'));
    //                 }
    //             } else if (currentAzimuthalAngle >= (Math.PI / 2 - camAngle) && currentAzimuthalAngle < ((Math.PI / 2 - camAngle) + camAngle * 2)) {
    //                 dispatch(setActiveBuildingWall('c_b_r_w'));
    //             } else if (currentAzimuthalAngle >= -((Math.PI / 2 - camAngle) + camAngle * 2) && currentAzimuthalAngle < -(Math.PI / 2 - camAngle)) {
    //                 dispatch(setActiveBuildingWall('c_b_l_w'));
    //             } else {
    //                 if (params.cB_addStorage_check_right === true && params.p_b_w != "Close") {
    //                     dispatch(setActiveBuildingWall('c_b_r_s_b_w'));
    //                 } else if (params.cB_addStorage_check_left === true && params.p_b_w != "Close") {
    //                     dispatch(setActiveBuildingWall('c_b_l_s_b_w'));
    //                 } else {
    //                     dispatch(setActiveBuildingWall('c_b_b_w'));
    //                 }
    //             }
    //         }
    //     } 
    //     const_var.componentsMoving = false;
    // }, 100)

    const handlePointerDown = () => {
        if (const_var.controls !== undefined) {
            if (controls.isCheckActiveTab !== 'doorwindow') {
                const_var.controls.enablePan = true;
                const_var.controls.target?.set(0, params.p_h / 2, 0);
            } else {
                if (params.activeWall.substring(0, 4) === 'c_b_') const_var.controls.target?.set(0, params.p_h / 2, 0);
                else if (params.activeWall.substring(0, 6) === 'G_L_L_') const_var.controls.target?.set(-params.p_w / 2 - params.lean_p_d / 2, params.lean_p_h / 2, params.lean_p_pos)
                else if (params.activeWall.substring(0, 6) === 'G_R_L_') const_var.controls.target?.set(params.p_w / 2 + params.leanR_p_d / 2, params.leanR_p_h / 2, params.leanR_p_pos)
                else if (params.activeWall.substring(0, 6) === 'G_F_L_') const_var.controls.target?.set(params.leanF_p_pos, params.leanF_p_h / 2, params.p_d / 2 + params.leanF_p_d / 2)
                else if (params.activeWall.substring(0, 6) === 'G_B_L_') const_var.controls.target?.set(params.leanB_p_pos, params.leanB_p_h / 2, -params.p_d / 2 - params.leanB_p_d / 2)
                else if (params.activeWall.substring(0, 4) === 'L_L_') const_var.controls.target?.set(-params.p_w / 2 - params.lean_p_w / 2, params.lean_p_h / 2, params.lean_p_pos)
                else if (params.activeWall.substring(0, 4) === 'R_L_') const_var.controls.target?.set(params.p_w / 2 + params.leanR_p_w / 2, params.leanR_p_h / 2, params.leanR_p_pos)
                else if (params.activeWall.substring(0, 4) === 'F_L_') const_var.controls.target?.set(params.leanF_p_pos, params.leanF_p_h / 2, (params.p_d + params.leanF_p_w) / 2)
                else if (params.activeWall.substring(0, 4) === 'B_L_') const_var.controls.target?.set(params.leanB_p_pos, params.leanB_p_h / 2, -(params.p_d + params.leanB_p_w) / 2)
                const_var.controls.enablePan = false;
            }
        }
    }
    useEffect(() => {
        let checkNatCarport = state.params.m_s_n == 184;
        if(checkNatCarport) {
            state.const_var.crmSetting.is_show_background= true
            document.querySelector('body').classList.add("activebuildingbg");
        } 
    },[state.params.m_s_n]) 
    return (
     <div className="canvas-box-wrapper">
        <div className="buildingcanvas">
            <span className="side-icon"></span>
            <span className="side-icon"></span>
            <span className="side-icon"></span>
            <span className="side-icon"></span>
            {/* <img
                alt='overlay img'
                className="overlay-logo-image"
                src={`${process.env.REACT_APP_BASE_URL}${WATERMARK_IMG}`}
            /> */}
            <div id="canvas-container">
                <Canvas
                    id='canvas'
                    gl={{ preserveDrawingBuffer: true }}  /* added gl parameter as capture photos was not working. */
                    camera={{
                        fov: "25",
                        near: 1,
                        far: 100000,
                        position: [-5, 0, -15],
                    }}
                    
                    onPointerDown={handlePointerDown}
                    // onPointerUp={handlePointerUp}
                >
                    <CanvasEnv />
                    <Suspense fallback={null}>
                        <Building />
                        <CameraController />
                    </Suspense>
                </Canvas>
            </div>
                <div className="modal-loading-wrapper">
                    <div className="modal-loading-wrapper-inner">
                        <div className="loader-for-modal"></div>
                    </div>
                </div>
        </div>
     </div>
    )
}

export default NewCanvas